import { Navigate } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';

const WorkflowsApp = lazyRetry(() => import('./WorkflowsApp'));
const WorkflowStepLayout = lazyRetry(() => import('./components/WorkflowStepLayout'));
const Capture = lazyRetry(() => import('./capture/Capture'));
const Index = lazyRetry(() => import('./index/Index'));
const Form = lazyRetry(() => import('./form/Index'));
const Download = lazyRetry(() => import('./download/Download'));
const Batches = lazyRetry(() => import('./batches/Batches'));

/**
 * The Academy app routes.
 */
const AcademyAppConfig: FuseRouteItemType = {
  path: 'workflows',
  element: <WorkflowsApp />,
  children: [
    {
      path: '',
      element: <Navigate to="/workflows/batches" />
    },
    {
      element: <WorkflowStepLayout />,
      children: [
        {
          path: 'capture/:batchId/*',
          element: <Capture />
        },
        {
          path: 'index/:batchId/*',
          element: <Index />
        },
        {
          path: 'form/:batchId/*',
          element: <Form />
        },
        {
          path: 'download/:batchId/*',
          element: <Download />
        }
      ]
    },
    {
      path: 'batches',
      element: <Batches />
    }
  ]
};

export default AcademyAppConfig;
